import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalNotice = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Link to="/" className="inline-flex items-center text-primary hover:text-primary-dark mb-8">
        <ArrowLeft className="h-5 w-5 mr-2" />
        Retour à l'accueil
      </Link>

      <h1 className="text-3xl font-bold text-primary mb-8">Mentions légales</h1>

      <div className="prose prose-lg">
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Éditeur du site</h2>
          <p>SimulReno<br />
          Ebelmann, Société par Actions Simplifiée<br />
          Capital social : 1000 €<br />
          RCS Strasbourg 944 366 343 00019<br />
          Siège social : 3 promenade des cardeurs, 67150 Erstein<br />
          Contact : contact@simulreno.com</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Hébergement</h2>
          <p>Le site SimulReno est hébergé par :<br />
          Netlify, Inc.<br />
          2325 3rd Street, Suite 215<br />
          San Francisco, California 94107<br />
          United States</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Protection des données personnelles</h2>
          <p>Conformément à la loi Informatique et Libertés du 6 janvier 1978 modifiée, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Vous pouvez exercer ce droit en nous contactant par email.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Propriété intellectuelle</h2>
          <p>L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé par le droit d'auteur. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Conditions d'utilisation</h2>
          <p>Les estimations fournies par SimulReno sont données à titre indicatif et ne constituent pas un engagement contractuel. Les prix peuvent varier selon les régions, les matériaux choisis et les conditions spécifiques de chaque chantier.</p>
        </section>
      </div>
    </div>
  );
};

export default LegalNotice;